import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/contexts/LanguageContext";

export default function FAQ() {
  const { t } = useLanguage();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="overline">{t.faq.overline}</p>
          <h2 className="font-display uppercase mt-4 text-4xl md:text-5xl tracking-tight">
            {t.faq.title}
          </h2>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10 first:border-t border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-lg md:text-xl font-medium tracking-tight py-6 hover:no-underline text-white hover:text-redflag [&[data-state=open]]:text-redflag"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="font-mono-plex text-xs text-white/40">
                      0{i + 1}
                    </span>
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-[15px] md:text-base text-white/70 leading-relaxed pb-6 pl-9 max-w-3xl"
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
